module.exports = __webpack_public_path__ + "media/icon/icon-bathtub-gray-10f3448d.svg";